<div class="chat-container">
  <div class="d-flex justify-content-end mb-2">
    <button class="btn btn-success btn-sm" (click)="initData()">
      <i class="fa-solid fa-sync"></i> Refresh
    </button>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th></th>
          <th>Instructions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="2">Loading...</td>
        </tr>
        <ng-container *ngIf="!isLoading">
          <tr *ngFor="let item of instructions; let i = index">
            <td>
              <button class="btn btn-sm btn-danger" (click)="handleDelete(i)">
                <i class="fa-solid fa-trash"></i>
              </button>
            </td>
            <td>{{ item }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>